class LookbookGalleryComponent extends HTMLElement {
  #grid = null;
  #dialogComponent = null;
  #swiperContainer = null;
  #swiper = null;

  connectedCallback() {
    this.#grid = this.querySelector('[ref="grid"]');
    this.#dialogComponent = this.querySelector('#lookbookDialog');
    this.#swiperContainer = this.querySelector('#lookbook-swiper');
    this.newLoadingModal = document.getElementById('new-loading-modal');
    if (!this.#grid || !this.#dialogComponent || !this.#swiperContainer) return;

    this.#bindTiles();
    this.#bindViewMore();
    this.#bindDialogEvents();
  }

  #bindDialogEvents() {
    const dialog = this.#dialogComponent.querySelector('dialog');
    if (!dialog) return;

    dialog.addEventListener('close', () => {
      if (this.#swiper) {
        this.#swiper.destroy(true, true);
        this.#swiper = null;
      }
      // this.#restoreScroll();
    });
  }

  #restoreScroll() {
    setTimeout(() => {
      const bodyStyle = window.getComputedStyle(document.body);
      if (bodyStyle.position === 'fixed') {
        const scrollY = parseInt(document.body.style.top || '0') * -1 || window.scrollY || 0;
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        window.scrollTo({ top: scrollY, behavior: 'instant' });
      }
      document.dispatchEvent(new Event('scroll', { bubbles: true }));
    }, 100);
  }

  disconnectedCallback() {
    if (this.#swiper) {
      this.#swiper.destroy(true, true);
      this.#swiper = null;
    }
  }

  #bindTiles() {
    this.#grid.querySelectorAll('[data-index]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (this.newLoadingModal) {
          this.newLoadingModal.showDialog();
        }
        const index = Number(btn.getAttribute('data-index')) || 0;
        this.#openDialogAndSelect(index);
       
      });
    });
  }

  #initializeSwiper() {
    if (!window.Swiper || !this.#swiperContainer) return;

    if (this.#swiper) {
      this.#swiper.destroy(true, true);
      this.#swiper = null;
    }

    const nextBtn = this.#swiperContainer.querySelector('.lookbook-swiper-button-next');
    const prevBtn = this.#swiperContainer.querySelector('.lookbook-swiper-button-prev');
    const pagination = this.#swiperContainer.querySelector('.lookbook-swiper-pagination');

    this.#swiper = new window.Swiper(this.#swiperContainer, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      speed: 300,
      navigation: nextBtn && prevBtn ? { nextEl: nextBtn, prevEl: prevBtn } : false,
      pagination: pagination ? { el: pagination, type: 'bullets', clickable: true } : false,
      keyboard: { enabled: true },
      observer: true,
      observeParents: true
    });

    setTimeout(() => {
      if (this.#swiper) {
        this.#swiper.update();
        this.#swiper.updateSize();
      }
    }, 200);
  }

  #openDialogAndSelect(index) {
    const dialogComponent = this.#dialogComponent;
    if (!dialogComponent) return;
    const initSwiper = () => {
      if (window.Swiper) {
        this.#initializeSwiper();
        setTimeout(() => {
          if (this.#swiper) this.#swiper.slideTo(index, 0);
        }, 100);
      } else {
        setTimeout(initSwiper, 50);
      }
      dialogComponent.showDialog?.();
      if (!dialogComponent.showDialog) {
        const dlg = dialogComponent.querySelector('dialog');
        if (dlg) dlg.showModal();
      }
      if (this.newLoadingModal) {
        this.newLoadingModal.closeDialog();
      }
    };

    setTimeout(initSwiper, 150);
    

  
  }

  #bindViewMore() {
    const grid = this.#grid;
    const moreBtn = this.querySelector('[data-action="view-more"]');
    if (!grid || !moreBtn) return;

    const step = parseInt(grid.getAttribute('data-per-page') || '12', 10);
    let extras = Array.from(grid.querySelectorAll('.is-extra'));
    let revealedCount = 0;
    let allVisible = false;

    const updateLabels = () => {
      const labelMore = moreBtn.querySelector('[data-label-more]');
      const labelLess = moreBtn.querySelector('[data-label-less]');
      if (labelMore) labelMore.hidden = allVisible;
      if (labelLess) labelLess.hidden = !allVisible;
    };

    updateLabels();

    moreBtn.addEventListener('click', () => {
      const spinner = moreBtn.querySelector('.lookbook-view-more__spinner');
      const labelMore = moreBtn.querySelector('[data-label-more]');
      const labelLess = moreBtn.querySelector('[data-label-less]');
      
      if (labelMore) labelMore.classList.add('hidden');
      if (labelLess) labelLess.classList.add('hidden');
      if (spinner) spinner.classList.remove('hidden');
      moreBtn.setAttribute('aria-busy', 'true');
      moreBtn.disabled = true;

      setTimeout(() => {
        extras = Array.from(grid.querySelectorAll('.is-extra'));

        if (!allVisible) {
          const toShow = extras.slice(revealedCount, revealedCount + step);
          toShow.forEach(el => {
            el.style.display = 'block';
            el.setAttribute('data-visible', 'true');
          });
          revealedCount += toShow.length;
          allVisible = revealedCount >= extras.length;
        } else {
          extras.forEach(el => {
            el.style.display = '';
            el.removeAttribute('data-visible');
          });
          revealedCount = 0;
          allVisible = false;
        }

        if (labelMore) labelMore.classList.remove('hidden');
        if (labelLess) labelLess.classList.remove('hidden');
        updateLabels();
        if (spinner) spinner.classList.add('hidden');
        moreBtn.removeAttribute('aria-busy');
        moreBtn.disabled = false;
      }, 1000);
    });
  }
}

if (!customElements.get('lookbook-gallery-component')) {
  customElements.define('lookbook-gallery-component', LookbookGalleryComponent);
}
